import { generateTableSlice } from "./sliceTable";

const sliceTaskListTable = generateTableSlice("taskListInReportingTab");

export const ActionsTaskListInReportingTab = sliceTaskListTable.actions;
export const ReducerTaskListInReportingTab = sliceTaskListTable.reducer;
